"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
var tslib_1 = require("tslib");
/* eslint-disable react/destructuring-assignment */
var react_1 = tslib_1.__importDefault(require("react"));
var controlled_1 = require("../form/controlled");
var noop_1 = require("../_util/noop");
var flatten_1 = require("../_util/flatten");
var SliderTrack_1 = require("./SliderTrack");
exports.Slider = react_1.default.forwardRef(function Slider(props, ref) {
    var _a = props.min, min = _a === void 0 ? 0 : _a, max = props.max, range = props.range;
    var rebuildValidRange = function (range) {
        var validRange = Array.isArray(range) ? range : [min, max];
        if (typeof validRange[0] !== "number" || validRange[0] < min) {
            validRange[0] = min;
        }
        if (typeof validRange[1] !== "number" || validRange[1] > max) {
            validRange[1] = max;
        }
        return validRange;
    };
    var validRange;
    if (props.rangeMode === true) {
        validRange = rebuildValidRange(range);
        return react_1.default.createElement(RangeSlider, tslib_1.__assign({ ref: ref }, props, { range: validRange }));
    }
    // 单值类型支持多区间
    validRange = Array.isArray(range) && range.length > 0 ? range : [];
    if (Array.isArray(range) &&
        (typeof range[0] === "number" || typeof range[1] === "number")) {
        validRange = [range];
    }
    validRange = validRange
        .filter(function (item) { return Array.isArray(item); })
        .map(function (item) { return rebuildValidRange(item); });
    return react_1.default.createElement(SingleSlider, tslib_1.__assign({ ref: ref }, props, { range: validRange }));
});
exports.Slider.displayName = "Slider";
var SingleSlider = react_1.default.forwardRef(function SingleSlider(props, ref) {
    var range = props.range, _a = props.dotValues, dotValues = _a === void 0 ? [] : _a, _b = props.min, min = _b === void 0 ? 0 : _b, max = props.max;
    var defaultValues = flatten_1.flatten(tslib_1.__spread(dotValues, range)).sort(function (a, b) {
        return a > b ? 1 : -1;
    });
    var defaultDefaultValue = defaultValues.length > 0 ? defaultValues[0] : 0;
    defaultDefaultValue = defaultDefaultValue < min ? min : defaultDefaultValue;
    defaultDefaultValue = defaultDefaultValue > max ? max : defaultDefaultValue;
    var _c = controlled_1.useDefaultValue(props, defaultDefaultValue), value = _c.value, onChange = _c.onChange, _d = _c.onUpdate, onUpdate = _d === void 0 ? noop_1.noop : _d;
    return (react_1.default.createElement(SliderTrack_1.SliderTrack, tslib_1.__assign({ ref: ref }, props, { value: [props.min || 0, value], onUpdate: function (value) {
            onUpdate(value[1]);
        }, onChange: function (value, context) {
            onChange(value[1], context);
        } })));
});
SingleSlider.displayName = "SingleSlider";
var RangeSlider = react_1.default.forwardRef(function RangeSlider(props, ref) {
    var defaultDefaultValue = props.range[0] || 0;
    var _a = controlled_1.useDefaultValue(props, [
        defaultDefaultValue,
        defaultDefaultValue,
    ]), value = _a.value, onChange = _a.onChange;
    return (react_1.default.createElement(SliderTrack_1.SliderTrack, tslib_1.__assign({ ref: ref }, props, { value: value, onChange: function (value, context) {
            onChange(value, context);
        } })));
});
RangeSlider.displayName = "RangeSlider";
//# sourceMappingURL=Slider.js.map